
import React, { useEffect, useState } from 'react';

import ar_vr_mainimg from "../../../assets/images/ar-vr-images/ar-vr-mainimg.png";
import Group263 from "../../../assets/images/homepage-images/Group263.svg";
import Group264 from "../../../assets/images/homepage-images/Group264.svg";
import Group265 from "../../../assets/images/homepage-images/Group265.svg";
import Group266 from "../../../assets/images/homepage-images/Group266.svg";
import products1 from "../../../assets/images/ar-vr-images/products-1.png";
import products2 from "../../../assets/images/ar-vr-images/products-2.png";
import products3 from "../../../assets/images/ar-vr-images/products-3.png";
import solution_1 from "../../../assets/images/ar-vr-images/solution-1.png";
import solution_2 from "../../../assets/images/ar-vr-images/solution-2.png";
import solution_3 from "../../../assets/images/ar-vr-images/solution-3.png";
import solution_4 from "../../../assets/images/ar-vr-images/solution-4.png";
import solution_5 from "../../../assets/images/ar-vr-images/solution-5.png";
import girlwithocolus from "../../../assets/images/ar-vr-images/girlwithocolus.png";
import virtual_bg from "../../../assets/images/virtualshowroom-images/virtual-bg.jpg";
import dots from "../../../assets/images/ar-vr-images/dots.png";
import ar_vr_bg from "../../../assets/images/ar-vr-images/ar-vr_bg.jpeg";
import brain_img from "../../../assets/images/onebox/brain.png";
import disruptSale_Img1 from "../../../assets/images/onebox/disruptSale1.svg";
import disruptSale_Img2 from "../../../assets/images/onebox/disruptSale2.svg";
import disruptSale_Img3 from "../../../assets/images/onebox/disruptSale3.svg";
import onebox_introVideo from "../../../assets/images/onebox/onebox_introVideo.mp4";
import sale_funnel_video from "../../../assets/images/onebox/saleFunnel.mp4";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from 'jquery';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { BrowserRouter, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './OneBox.css';


function OneBox() {

    var ProductSettings = {
        infinite: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        lazyLoad: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 10000,
        pauseOnHover: false,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };
    useEffect(() => {
        $(".navbar").css("background", "transparent");
        $(".navbar").css("box-shadow", "none")
        setTimeout(() => {
            AOS.init();
        }, 2000);
        var btn = $('#button');
        const handleScroll = () => {
            if (window.pageYOffset > 500) {
                btn.addClass("show");
                $(".navbar").css("background", "#fff");
                $(".navbar").css("box-shadow", "0px 15px 10px -15px #111")
            }
            else if (window.pageYOffset < 500) {
                btn.removeClass("show");
                $(".navbar").css("background", "transparent");
                $(".navbar").css("box-shadow", "none")
            }
        };
        window.addEventListener('scroll', handleScroll);

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

        btn.on('click', function (e) {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        });

    }, []);

    return (
        <>

            <Helmet>
                <title>OneXR - OneBox</title>
                <meta name="description" content="Reduce Sales cycle time with Interactive Virtual Demos! Let your prospects preview products in 360-Degree in real size in any environment instantly! Engage all ..." />
            </Helmet>
            <div className="warpper1 fadein">
                <a id="button"><i className="bi bi-arrow-up-square-fill"></i></a>
                {/* <div className="ar-vr-main oneBox_main" style={{ backgroundImage: 'linear-gradient(to bottom, #ffffff, #fdfeff, #f8fdff, #f3fdff, #f0fdfa)' }}>
                    <div className="row">
                        <div className="col-12 p-5 ">
                            <div className="container mt-5 text-center">
                                <h1>OneBox</h1>
                                <h2>Turn Your Sales Meetings Into Conversions with</h2>
                                <h2 className='onebox_text_gradient'>AI-XR Technology</h2>
                                <p className='text-center my-3'> The AI-XR tool that increases sales by over 20% and decreases CAC by over 25% for OEMs. Experience the power of Gen AI and XR to boost your RFPs by 50%, so your win ratio would be in the same proportion.</p>
                            </div>
                            <div className="container text-center mt-4">
                                <button className='oneBox_startDemo_btn mx-2'>Start Your Demo</button>
                                <button className='oneBox_watchVideo_btn mx-2'><i class="bi bi-play-circle"></i> Watch Video</button>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className="ar-vr-main" style={{ backgroundImage: 'linear-gradient(180deg, #FFFFFF 0%, #B7D3E6 100%)', padding: '4% 0' }}>
                    <div className="row">
                        <div className="col-12 col-lg-6 p-5 ">
                            <div className="mt-5">
                                <h1>OneXR</h1>
                                <h2 className='oneBox_hero_head'>Disrupt Your Sales with <span> OneBox</span></h2>
                                <p className='p-0 mt-3'>OneBox, an AI-XR tool, boosts sales by over 20% and cuts Customer Acquisition Cost (CAC) by over 25% for Original Equipment Manufacturers (OEMs). Leveraging Gen AI and XR, OneBox can potentially increase your Requests for Proposals (RFPs) by 50%, maintaining your win ratio. It's more than just real-time AI-driven sales conversation support; it's about enhancing customer engagement with immersive visual content, ensuring deeper understanding and retention. OneBox acts as a Conversation Intelligence tool, a Co-pilot for your sales representatives, making every interaction impactful and expert-level.</p>
                                <button className='oneBox_startDemo_btn'>Request a Demo →</button>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 mt-5">
                            <div className='homeVideo_section m-4'>
                                <video width="320" height="240" autoPlay muted controls={false} >
                                    <source src={onebox_introVideo} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                                <h6 className='homeVideo_section_head mt-2'>AI-XR Demo Preview</h6>
                                <p>Experience immersive sales conversations that convert prospects into customers with our revolutionary AI-XR platform.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="benefits pt-4 pb-4 ps-0">
                    <div className="container">
                        <div className='row'>
                            <div className="col-lg-3 col-md-3">
                                <card className="card onebox_benefits_card px-4 pt-2 pb-4 my-2">
                                    <div className='onebox_benefits_head my-2'><h1>20%+</h1></div>
                                    <div className='onebox_benefits_disc'><h5>Sales Increase</h5></div>
                                </card>
                            </div>
                            <div className="col-lg-3 col-md-3">
                                <card className="card onebox_benefits_card px-4 pt-2 pb-4 my-2">
                                    <div className='onebox_benefits_head my-2'><h1>25%</h1></div>
                                    <div className='onebox_benefits_disc'><h5>Lower CAC</h5></div>
                                </card>
                            </div>
                            <div className="col-lg-3 col-md-3">
                                <card className="card onebox_benefits_card px-4 pt-2 pb-4 my-2">
                                    <div className='onebox_benefits_head my-2'><h1>50%</h1></div>
                                    <div className='onebox_benefits_disc'><h5>More RFPs</h5></div>
                                </card>
                            </div>
                            <div className="col-lg-3 col-md-3">
                                <card className="card onebox_benefits_card px-4 pt-2 pb-4 my-2">
                                    <div className='onebox_benefits_head my-2'><h1>100%</h1></div>
                                    <div className='onebox_benefits_disc'><h5>Attention Rate</h5></div>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="oneBox-products container mb-">
                    <div className="content-row1">
                        <div className="my-5">
                            <h1 className='oneBox_hero_head'>Why <span> OneBox </span>  Changes Everything </h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-lg-6 col-md-6">
                            <div className="card-container">
                                <div className="oneBox_disruptSale_content">
                                    <h2 className='oneBox_disruptSale_head oneBox_hero_head'>Disrupt Your Sales with <span> OneBox</span></h2>
                                    <p>It's not just Gen AI providing real-time sales conversation, facilitating the sales conversation, and providing notes and intelligence to your reps, but it brings in visual content they can experience and understand rather than hearing from the sales rep.</p>
                                    <p>This means customer attention, exposure to register the point is over 100% rather than just hearing from the rep.</p>
                                    <p>The goal is to create a must-have solution with urgency rather than a nice-to-have product.</p>
                                    <p>A business expert can do this, but it is not always possible on every sales call or by everyone.</p>
                                    <p>That is why we built a Conversation Intelligence tool, a Co-pilot for your Sales reps.</p>
                                    <p>The goal is not just to have displays but to contribute and enhance the salesperson's intelligence live during the sales conversation </p>
                                    <p>we help to understand customers' language and even try to speak in their language, constructing the information on the fly and presenting it visually, aiding the sales rep to make an deep engaging conversion.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 col-md-6">
                            <div className="card-container h-100">
                                <div className='row'>
                                    <div className='col-12 col-md-6 col-lg-6'>
                                        <card className="card sales_copilot_card px-4 pt-2 pb-4 my-2">
                                            <div className='sales_card_icon'><i><img src={brain_img} /></i></div>
                                            <div className='sales_card_head my-2'><h5>AI Intelligence</h5></div>
                                            <div className='sales_card_disc'>Real-time conversation support and personalized responses</div>
                                        </card>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-6'>
                                        <card className="card sales_copilot_card px-4 pt-2 pb-4 my-2">
                                            <div className='sales_card_icon'><i class="bi bi-eye"></i></div>
                                            <div className='sales_card_head my-2'><h5>XR Visualization</h5></div>
                                            <div className='sales_card_disc'>Immersive 30 product experiences and environments</div>
                                        </card>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-6'>
                                        <card className="card sales_copilot_card px-4 pt-2 pb-4 my-2">
                                            <div className='sales_card_icon'><i class="bi bi-lightning-charge"></i></div>
                                            <div className='sales_card_head my-2'><h5>Instant Impact</h5></div>
                                            <div className='sales_card_disc'>20%+ sales increase and 25%+ CAC reduction</div>
                                        </card>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-6'>
                                        <card className="card sales_copilot_card px-4 pt-2 pb-4 my-2">
                                            <div className='sales_card_icon'><i class="bi bi-chat-left"></i></div>
                                            <div className='sales_card_head my-2'><h5>Smart Conversation</h5></div>
                                            <div className='sales_card_disc'>Persona-baned storytelling and multilingual support</div>
                                        </card>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div>
                    <hr style={{ margin: "3% 7%" }} />
                </div>

                <div className='container'>
                    <div className="content1 text-center my-5">
                        <h1 className='oneBox_hero_head'>Go on and Disrupt <span> Your Sales </span> </h1>
                        <p> <span style={{ color: '#1495D6', fontWeight: '800' }}>Power of AI and XR: </span>Turn your meetings into conversions for go-getters and change-makers We are not building something that will replace Sales Engineers, but it would replace sales engineers who aren't using it There are two rising tides, AI and XR. The rising tide raises all ships. If you are not with the rising tide, chances are you sink. Make use of the rising tide to move forward.</p>
                    </div>

                    <div className="row m-0 pt-2 pb-2">
                        <div className='oneBox_disruptSale_content'>
                            <h4 className='text-center'>Elevate every sales conversation with a real-time co-pilot you can take with you and fly confidently. </h4>
                            <p>We enable organizations to integrate unstructured data at scale efficiently. Combining the superpowers of technology. Generative AI and XR to build engaging conversions and insights for you to win. Let us worry about data integration, governance, enrichment, LLM readiness, visual presentation, gathering and addressing pain points of customers, and creating the decision-making criteria for customers that favor you. OneBox provides sales conversational intelligence, understanding customers' needs, and provides live recommendations using generative AI. </p>
                        </div>
                        <div className="col-lg6 col-md-6">
                            <div className="content1 my-2 oneBox_disruptSale_content">
                                <p>
                                    We combine AI with XR (Virtual 3D demonstrations), both powerful emerg(ed/ing) technologies to facilitate sales conversations like an expert and beyond. The main objective of a sales pitch and a demo is to show how your product solves customer pain points and position your solution as the most efficient way to achieve their goals in increasing production, saving resources & cost, reducing risk, or being in compliance. As you strive to be an innovator and changemaker, you seek solutions to distinguish yourself as an industry leader and disruptor in conducting business for good. We believe you might like what we have here if that is you. On the sales front, we ask the same tough and right questions about why the sales pitch failed and dig deep into the answers. Today's fast-paced technology has revolutionized and simplified the way we engage in business transactions. We believe OneBox is a one-of-a-kind solution for changemakers to dig deep and embrace disruption when conducting sales conversations.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6  d-flex justify-content-center align-items-center">
                            <div className='homeVideo_section'>
                                <video width="320" height="240" autoPlay muted controls={false} >
                                    <source src={sale_funnel_video} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </div>

                    <div className=" row m-0 mt-4 pt-5 pb-2">
                        <div className="col-lg-4 col-md-4">
                            <card className="card disruptSale_section px-3 pt-3 pb-4 my-2">
                                <img className='disruptSale_img' src={disruptSale_Img1} alt='image' />
                                <div className='disruptSale_section_head my-2'><h6>Increased Sales Conversion</h6></div>
                                <div className='disruptSale_section_disc'>Close more deals with AI-driven insights and personalized interactions.</div>
                            </card>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <card className="card disruptSale_section px-3 pt-3 pb-4 my-2">
                                <img className='disruptSale_img' src={disruptSale_Img2} alt='image' />
                                <div className='disruptSale_section_head my-2'><h6>Reduced Customer Acquisition Cost</h6></div>
                                <div className='disruptSale_section_disc'>Lower your customer acquisition cost by optimizing sales processes.</div>
                            </card>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <card className="card disruptSale_section px-3 pt-3 pb-4 my-2">
                                <img className='disruptSale_img' src={disruptSale_Img3} alt='image' />
                                <div className='disruptSale_section_head my-2'><h6>Enhanced Sales Team Productivity</h6></div>
                                <div className='disruptSale_section_disc'>Empower your sales team to achieve more in less time.</div>
                            </card>
                        </div>
                    </div>
                </div>

                <div className='container comparison_container'>
                    <div className="sticky-comparison-header mb-4">
                        <div className="content1 text-center mt-5 w-100">
                            <h1 className='oneBox_hero_head'>Transform  <span> Your Sales </span> Process</h1>
                            <div className='d-flex justify-content-around align-items-center my-3'>
                                <div className='comparison_head_traditional'>Traditional Sales</div>
                                <div className='comparison_head_onebox'>OneBox</div>
                            </div>
                        </div>
                        <div>
                            <hr />
                        </div>
                    </div>

                    <div className="row comparison_box">
                        <div className="col-lg-6 col-md-6">
                            <div>
                                <h4 className='comparison_innterHead'>Sales Productivity (80/20 Rule)</h4>
                            </div>
                            <div className='comparison_traditional'>
                                <ul>
                                    <li>20% of the sales force produces over 50% of the revenue, and 80% of the revenue comes from the rest of the team.</li>
                                    <li>Most OEMs depend on channel partners (dealers and independent reps) who play a significant role.</li>
                                    <li>10% of sales folks are expert business consultants. 50% have mediocre skills, and the rest are in transition</li>
                                    <li>Other than experts, most are good at catalog sales, repeating the same pitch to everyone rather than personalizing it to the customer's persona</li>
                                    <li>Expert sales reps are always in demand. The risk of losing good consultative salespeople is painful, as they bring most of the revenue, network, and relationships.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className='comparison_onebox'>
                                <ul>
                                    <li>With OneBox (VR-enabled with AI), an organized, technology-facilitated visual conversation aids every salesperson with expert knowledge to be a producer</li>
                                    <li>The system provides details and facilitates visual conversation trained by AI, reducing the time needed to be productive in the field within weeks instead of months</li>
                                    <li>With the help of AI workflow, the system tailors its conversation to the customer's persona (plant manager, engineer, R&D manager, etc.) with visual interactions that they understand</li>
                                    <li>Provide a memorable experience, instant knowledge, and build trust to reduce the buying cycle of customers.</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row comparison_box">
                        <div className="col-lg-6 col-md-6">
                            <div>
                                <h4 className='comparison_innterHead'>Channel partners pains</h4>
                            </div>
                            <div className='comparison_traditional'>
                                <ul>
                                    <li>OEMs depend on Dealers or independent sales reps. Unfortunately, they are not the experts on your product, and hence, they do not have answers to all customer needs and depend on the experts back at HQ</li>
                                    <li>Depend heavily on experts for objective handling or value demonstration to provide customized technical explanations for solutions and to earn trust with case studies and more.</li>
                                    <li>They tend to demo what they are comfortable with (the last sale made or products they know well), which can result in multiple meetings and longer durations or lost sales.</li>
                                    <li>There is no clear visibility of sales efforts to the business.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className='comparison_onebox'>
                                <ul>
                                    <li>One Box facilitates channel partners with expert knowledge, articulates with a visual demonstration of the product of all scenarios to various personas, asks the right questions, and handles objective questions, creating the need like that of an expert interaction</li>
                                    <li>It can also track all sales demos and conversations and provide precise reports on customer conversations and action plans.</li>
                                    <li>You now have instant and clear visibility of all sales transitions as they take place within VR.</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row comparison_box">
                        <div className="col-lg-6 col-md-6">
                            <div>
                                <h4 className='comparison_innterHead'>Lack of Knowledge Repository and training</h4>
                            </div>
                            <div className='comparison_traditional'>
                                <ul>
                                    <li>Most businesses do not organize the experts' documentation of sales techniques, conversation, and know-how.</li>
                                    <li>The product's knowledge repository, value points, varied customer pain points by personas, objective handling, competition, case studies, and testimonials are poorly documented and/or organized, or shared across organizations.</li>
                                    <li>Experts are busy with their primary work and meeting their sales goals, and not all are good trainers.</li>
                                    <li>They do not prioritize documenting their expertise, training, or sharing knowledge from experts, and some customer-centric information does not exist on the company website.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className='comparison_onebox'>
                                <ul>
                                    <li>With OneBox, your experts train AI systems in knowledge (Knowledge is retained and improved continuously). This knowledge is centralized for your team, used effectively, and shared across the business, reducing dependencies and creating a productive sales force.
                                    </li>
                                    <li>The power of AI, combined with augmented and virtual reality, facilitates your sales reps' live conversing to converse like experts, with context-sensitive personalized data articulating values. It handles objective questions and builds trust and authority with context-sensitive case studies.</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row comparison_box">
                        <div className="col-lg-6 col-md-6">
                            <div>
                                <h4 className='comparison_innterHead'>Attrition and Sales Training Cost</h4>
                            </div>
                            <div className='comparison_traditional'>
                                <ul>
                                    <li>The manufacturing industry averages 15% Attrition among sales reps (Forrester report)</li>
                                    <li>U.S. firms spend over $7 billion on sales training every year. The average cost of developing a single salesperson exceeds USD $100,000 (the annual cost of a sales rep).</li>
                                    <li>Losing a producing salesperson is a risk for businesses as they carry out customer relations.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className='comparison_onebox'>
                                <ul>
                                    <li>With OneBox, the AI-XR does the heavy lifting. Salespeople can confidently explain the answers visually with engaging interactive demos and converse like experts.</li>
                                    <li>You save on training and sales personnel costs, create productive sales reps within weeks instead of months, hit their goals with less attrition, and increase RFPs.</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row comparison_box">
                        <div className="col-lg-6 col-md-6">
                            <div>
                                <h4 className='comparison_innterHead'>Language Barrier</h4>
                            </div>
                            <div className='comparison_traditional'>
                                <ul>
                                    <li>Not all sales reps converse in customers' languages and cannot connect, and would depend on others for translation. This leads to lengthier sales times or entirely missed sales.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 ">
                            <div className='comparison_onebox'>
                                <ul>
                                    <li>
                                        With OneBox, you do not have a language barrier. You can now understand and converse instantly in many supported languages with a built-in live AI language translation.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row comparison_box">
                        <div className="col-lg-6 col-md-6 ">
                            <div>
                                <h4 className='comparison_innterHead'>Longer Sales Cycle</h4>
                            </div>
                            <div className='comparison_traditional'>
                                <ul>
                                    <li>The sales process involves more in-person touchpoints. Averages 5 in personal meetings.</li>
                                    <li>This is to schedule customer stakeholders to experience the product or to visit the facility.</li>
                                    <li>Get all experts to exchange knowledge and answer the customer's questions, as the initial meetings by the sales rep do not provide answers for all.</li>
                                    <li>Therefore, meetings are postponed to gather information or to bring in all stakeholders.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className='comparison_onebox'>
                                <ul>
                                    <li>OneBox, with generative AI, answers most of the queries instantly with a virtual product in a virtually simulated customer environment.</li>
                                    <li>Bring all stakeholders and experts instantly within the virtual scene (Metaverse) to witness the demo, simulate scenarios that are not possible in real-time, and take them on a virtual tour of your facility.</li>
                                    <li>With an involved and effective stakeholder meeting, you now have fewer meetings, resulting in a faster sales cycle and increased conversion</li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div className="row comparison_box">
                        <div className="col-lg-6 col-md-6">
                            <div>
                                <h4 className='comparison_innterHead'>Poor visibility of Sales meetings</h4>
                            </div>
                            <div className='comparison_traditional'>
                                <ul>
                                    <li>Documentation on sales conversations is not done in CMS on time or is never or is biased.</li>
                                    <li>There needs to be more consistency in the sales pitch across the sales team.</li>
                                    <li>Businesses need more information about sales reps' actual sales interactions with customers.</li>
                                    <li>As a result, there is a heavy dependency on retaining and expanding existing customers; it takes work to expand to new markets.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 ">

                            <div className='comparison_onebox'>
                                <ul>
                                    <li>Poor visibility of Sales meetings.</li>
                                    <li>Documentation on sales conversations is not done in CMS on time or is never or is biased.</li>
                                    <li>
                                        There needs to be more consistency in the sales pitch across the sales team.
                                        Businesses need more information about sales reps' actual sales interactions with customers.
                                    </li>
                                    <li>
                                        As a result, there is a heavy dependency on retaining and expanding existing customers; it takes work to expand to new markets.	With OneBox, sales reps are consistent in their sales conversations as they are aided by VR/AI, and all sales conversations can be recorded.
                                    </li>
                                    <li>
                                        The system transcribes the conversations into precise sections on customer needs, pain points, ROI justification, decision-making criteria, and action plans discussed.
                                    </li>
                                    <li>
                                        These data are vital for businesses to understand the effectiveness of sales reps, and they are all recorded and available in CMS instantly.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row comparison_box">
                        <div className="col-lg-6 col-md-6">
                            <div>
                                <h4 className='comparison_innterHead'>OEM’s conversion rate at 3%</h4>
                            </div>
                            <div className='comparison_traditional'>
                                <ul>
                                    <li>
                                        A significant number of qualified leads do not materialize into RFPs due to a lack of product in hand, a poor sales pitch, and other reasons, and most depend on traditional methods
                                    </li>
                                    <li>You would think this is normal as this is average (normality) across the industry.</li>
                                    <li>Why would more than 70% of a qualified prospect's sales pitch fail? Most of the sales reps have various answers to justify their point of view. However, we don’t dig deep into why this could have been a success.</li>
                                    <li>When a business does not win, it impacts the brand, and it takes work to regain trust after a lost sale</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 ">
                            <div className='comparison_onebox'>
                                <ul>
                                    <li>
                                        With OneBox, the failure rates are very low, and that is not due to poor sales demos and pitches but to other reasons.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row comparison_box">
                        <div className="col-lg-6 col-md-6">
                            <div>
                                <h4 className='comparison_innterHead'>Lack of Sales Business experts</h4>
                            </div>
                            <div className='comparison_traditional'>
                                <ul>
                                    <li>Not all sales reps are experts in addressing Customer discoveries, pain points, and or needs instantly and accurately.</li>
                                    <li>Customers are not justified by ROI and value, creating an urge to change to a must-have product rather than a nice-to-have one</li>
                                    <li>The customer's decision-making criteria are not identified accurately and/or created to be favorable for the business.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className='comparison_onebox'>
                                <ul>
                                    <li>
                                        OneBox’s AI aids the sales conversation by visually extracting and addressing pain points.
                                    </li>
                                    <li>It can gather information from customer stakeholders, articulating values with the virtual demonstration of solutions, creating ROI metrics tailored to customers with their data, and a compelling need for the product, justifying the need.</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    );
}

export default OneBox;

